import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6afaca20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewLimit" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Показано", -1))
const _hoisted_3 = {
  key: 0,
  class: "flex items-center ml-2"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "из", -1))
const _hoisted_5 = {
  key: 1,
  class: "font-semibold ml-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_the_select, {
      class: "ml-2",
      disabled: _ctx.disabled,
      value: _ctx.value,
      options: _ctx.LIMITS,
      searchable: false,
      label: "value",
      "select-by": "value",
      onChange: _ctx.onChange
    }, null, 8, ["disabled", "value", "options", "onChange"]),
    (_ctx.totalItems || _ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_loader, {
                key: 0,
                class: "primary ml-2"
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.totalItems), 1))
        ]))
      : _createCommentVNode("", true)
  ]))
}